import type { Dispatch, SetStateAction } from 'react';
import { Offcanvas, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import SolarIcon from 'components/icons/SolarIcon';
import vconst from 'utils/helpers/structs/vconst';
import { useObjectCard } from '../context/ObjectCardProvider';
import TabGeneral from './tabs/TabGeneral';
import TabWorkers from './tabs/TabWorkers';
import { getExpendIncomeStatus, useExpendTeamInfo } from './model';

interface OffExpendTeamInfoProps {
    show: number | false;
    setShow: Dispatch<SetStateAction<number | false>>;
}

const OffExpendTeamInfo = ({ show, setShow }: OffExpendTeamInfoProps) => {
    const { t } = useTranslation(['Objects']);
    const { objectId, isEditLocked } = useObjectCard();
    const { data, reload, activeTab, setActiveTab } = useExpendTeamInfo(objectId, show);

    const handleHide = () => {
        setShow(false);
    };

    const incomeStatus = getExpendIncomeStatus(data?.expend);
    const readOnly = Boolean(isEditLocked) || incomeStatus === vconst.incomeStatCancel;
    const expendId = Number(show) || Number(data?.expend?.ID) || 0;

    return (
        <Offcanvas
            className="off-import"
            show={show !== false}
            onHide={handleHide}
            placement="end"
        >
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('titleOperInfo')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                {data?.expend ? (
                    <div className="off-expend-team-tabs d-flex flex-column h-100">
                        <Tabs
                            variant="underline"
                            id="off-expend-team-info-tab"
                            className="b-3 invoice-tab border-bottom px-3"
                            activeKey={activeTab}
                            onSelect={(key) =>
                                key && setActiveTab(key as 'general' | 'workers')
                            }
                        >
                            <Tab
                                eventKey="general"
                                title={
                                    <>
                                        <SolarIcon name="info-circle" className="me-2 fs-14" />
                                        {t('expendTeamWorkers.tabGeneral')}
                                    </>
                                }
                            >
                                <div className="off-create-team-content pt-3">
                                    <TabGeneral expendTeam={data} />
                                </div>
                            </Tab>
                            <Tab
                                eventKey="workers"
                                title={
                                    <>
                                        <SolarIcon name="people" className="me-2 fs-14" />
                                        {t('expendTeamWorkers.tabWorkers')}
                                    </>
                                }
                            >
                                {objectId && expendId ? (
                                    <TabWorkers
                                        objectId={Number(objectId)}
                                        expendId={expendId}
                                        expendTeam={data}
                                        readOnly={readOnly}
                                        onSaved={reload}
                                    />
                                ) : null}
                            </Tab>
                        </Tabs>
                    </div>
                ) : (
                    <ESpinner />
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffExpendTeamInfo;
